import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaDataTable from './VaDataTable.vue'

export default withConfigTransport(VaDataTable)
